import { render, staticRenderFns } from "./VipRedeemPopup.vue?vue&type=template&id=242b6fe0&scoped=true"
import script from "./VipRedeemPopup.vue?vue&type=script&lang=js"
export * from "./VipRedeemPopup.vue?vue&type=script&lang=js"
import style0 from "./VipRedeemPopup.vue?vue&type=style&index=0&id=242b6fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b6fe0",
  null
  
)

export default component.exports